const initialState = {
    isLoading: false,

    count_appusers: "0",
    count_appusers_sendwarranty: "0",
    count_allwarranty: "0",
    count_confirmwarranty: "0",
    count_noconfirmwarranty: "0",
    count_waitconfirmwarranty: "0",

    mapData: {},
    warranty_region: {
        report_region: [],
        total_warranty: "0",
        total_percent_region: "100"
    },
}

const reportReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_COUNTAPPUSERS": {
            return {
                ...state,
                count_appusers: action.data
            }
        }
        case "GET_COUNTAPPUSERS_SENDWARRANTY": {
            return {
                ...state,
                count_appusers_sendwarranty: action.data
            }
        }
        case "GET_COUNT_ALL_WARRANTY": {
            return {
                ...state,
                count_allwarranty: action.data
            }
        }
        case "GET_COUNT_CONFIRM_WARRANTY": {
            return {
                ...state,
                count_confirmwarranty: action.data
            }
        }
        case "GET_COUNT_NOCONFIRM_WARRANTY": {
            return {
                ...state,
                count_noconfirmwarranty: action.data
            }
        }
        case "GET_COUNT_WAITCONFIRM_WARRANTY": {
            return {
                ...state,
                count_waitconfirmwarranty: action.data
            }
        }
        case "GET_WARRANTYREGION": {
            let data = action.data;

            let warranty_region = {
                report_region: data.report_region,
                total_warranty: data.total_warranty,
                total_percent_region: data.total_percent_region
            }

            return {
                ...state,
                warranty_region: warranty_region,
                mapData: action.mapData
            }
        }
        default: {
            return state
        }
    }
}

export default reportReducer;